<template>
    <div class="w-full">
        <div v-for="(phone, index) in phones" :key="index">
            <div class="w-full flex items-center">
                <div class="w-full relative">
                    <input class="input pl-8" v-model="phone.number" placeholder="(DDD) Número" data-no-mask />
                    <div class="absolute inset-y-0 left-0 mx-2 flex items-center">
                        <alo-dropdown>
                            <button
                                type="button"
                                class="
                                    mt-2
                                    text-gray-500
                                    hover:bg-gray-100 hover:text-black
                                    dark:hover:text-white
                                    rounded-full
                                "
                            >
                                <svg
                                    v-if="phone.type == 'landline'"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-4 w-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                                    />
                                </svg>

                                <svg
                                    v-if="phone.type == 'mobile'"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-4 w-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </button>

                            <template #menu>
                                <alo-dropdown-item
                                    :selected="phone.type == 'landline'"
                                    @click.native="phone.type = 'landline'"
                                    close-dropdown
                                >
                                    {{ __('Fixo') }}
                                </alo-dropdown-item>

                                <alo-dropdown-item
                                    :selected="phone.type == 'mobile'"
                                    @click.native="phone.type = 'mobile'"
                                    close-dropdown
                                >
                                    {{ __('Celular') }}
                                </alo-dropdown-item>
                            </template>
                        </alo-dropdown>
                    </div>
                </div>

                <div class="m-2 flex-shrink-0 flex items-center space-x-2">
                    <button type="button" class="p-1 rounded-full bg-gray-100 hover:bg-gray-200" @click="remove(index)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <button
            type="button"
            class="p-1 text-sm px-3 flex items-center space-x-1 rounded-full bg-gray-100 hover:bg-gray-200"
            @click="add()"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            <span>{{ __('Incluir telefone') }}</span>
        </button>
    </div>
</template>

<script>
import Inputmask from 'inputmask'

export default {
    props: ['value', 'field'],
    computed: {
        placeholder() {
            return Form.placeholder(this.field)
        },
    },
    watch: {
        phones: {
            deep: true,
            handler(value) {
                this.$emit('input', value)
            },
        },
    },
    mounted() {
        this.maskApply = new Inputmask(['(99) 9999-9999', '(99) 99999-9999'])

        this.$el.validateRequired = () => {
            return this.phones.length > 0 && this.phones[0].number.length >= 10
        }

        this.applyMasks()
    },
    data() {
        return {
            phones: this.value || [{ number: '', type: 'landline' }],
        }
    },
    methods: {
        add() {
            this.phones.push({ number: '', type: 'landline' })
            this.$nextTick(() => {
                this.applyMasks()
            })
        },
        remove(index) {
            this.phones.splice(index, 1)
        },
        applyMasks() {
            Array.from(this.$el.querySelectorAll('input[data-no-mask]')).forEach((input) => {
                this.maskApply.mask(input)
                input.setAttribute('data-no-mask', false)
            })
        },
    },
}
</script>